module.exports = __webpack_public_path__ + "static/media/5.88068d71.jpg";